import * as read_api from "./alan_api";
function serialize_plural_type_arguments($_plural_type_arguments: read_api.Cplural_type_arguments) {
	const raw_data: Record<string, any> = {};
	{
		let raw_has_step: Record<string, any>;
		switch ($_plural_type_arguments.properties.has_step.state.name) {
			case 'no': {
				const $_no = $_plural_type_arguments.properties.has_step.state.node;
				const raw_data: Record<string, any> = {};
				raw_has_step = raw_data
				break;
			}
			case 'yes': {
				const $_yes = $_plural_type_arguments.properties.has_step.state.node;
				const raw_data: Record<string, any> = {};
				raw_data["key"] = $_yes.properties.key;
				raw_data["tail"] = serialize_plural_type_arguments($_yes.properties.tail);
				raw_has_step = raw_data
				break;
			}
			default:
				throw new Error("unexpected state: " + $_plural_type_arguments.properties.has_step.state)
		}
		raw_data["has step"] = [$_plural_type_arguments.properties.has_step.state.name, raw_has_step];
	}
	return raw_data;
}
export function serialize($_arguments: read_api.Carguments) {
	const raw_data: Record<string, any> = {};
	const raw_arguments: Record<string, any> = {};
	for (let [k,v] of $_arguments.properties.arguments) {
		const $_arguments__ = v;
		const raw_data: Record<string, any> = {};
		{
			let raw_type: Record<string, any>;
			switch ($_arguments__.properties.type.state.name) {
				case 'number': {
					const $_number = $_arguments__.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["value"] = $_number.properties.value.value;
					raw_type = raw_data
					break;
				}
				case 'text': {
					const $_text = $_arguments__.properties.type.state.node;
					const raw_data: Record<string, any> = {};
					raw_data["value"] = $_text.properties.value;
					raw_type = raw_data
					break;
				}
				default:
					throw new Error("unexpected state: " + $_arguments__.properties.type.state)
			}
			raw_data["type"] = [$_arguments__.properties.type.state.name, raw_type];
		}
		raw_arguments[k] = raw_data
	}
	raw_data["arguments"] = raw_arguments;
	raw_data["context node"] = serialize_plural_type_arguments($_arguments.properties.context_node);
	return raw_data;
}